import React, {Component} from 'react';
import Nav from 'reactstrap/es/Nav';
import NavItem from 'reactstrap/es/NavItem';
import {ChangeQuarter, ChangeStatus, ChangeYear} from '../Options';
import {Col, Row} from 'reactstrap';
import autobind from 'autobind-decorator';

export default class InvoiceContainer extends Component {

    @autobind
    changeType(type) {
        this.props.setCurrentType(type);
    }

    render() {
        return (
            <Row>
                <Col sm={2} className='mt-3'>
                    <Nav vertical>
                        <NavItem>
                            <ChangeYear/>
                        </NavItem>
                        <hr/>
                        <NavItem>
                            <ChangeQuarter/>
                        </NavItem>
                        <hr/>
                        <NavItem>
                            <ChangeStatus/>
                        </NavItem>
                    </Nav>
                </Col>
                <Col sm={10} className='mt-3'>
                    {this.props.children}
                </Col>
            </Row>
        )
    }
}
